import { render, staticRenderFns } from "./Teammessage.vue?vue&type=template&id=25b6ee64&scoped=true"
import script from "./Teammessage.vue?vue&type=script&lang=js"
export * from "./Teammessage.vue?vue&type=script&lang=js"
import style0 from "./Teammessage.vue?vue&type=style&index=0&id=25b6ee64&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b6ee64",
  null
  
)

export default component.exports